// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"570":"37499891de222a96","1358":"f050bb421e857173"}[chunkId] + ".js";
};